import {Component, input, model} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BaseInput} from '../base-input/base-input';

@Component({
  selector: 'app-text-area',
  imports: [
    FormsModule
  ],
  templateUrl: './text-area.html',
  styleUrl: './text-area.css',
})
export class TextArea extends BaseInput {
  rows = input<number>(20);
  cols = input<number>(2);
  value = model<string | number>('');
  maxlength = input<number>();
  minlength = input<number>();
  labelBackground = input<string>('bg-white dark:bg-gray-900');
  autocomplete = input<string>();
  resize = input<string>('block');
}
